@if (visible()) {
	<header class="flex h-12 w-full items-center gap-1 bg-gray-000 px-1 text-gray-700">
		<div class="flex min-w-0 flex-1 items-center gap-px">
			@if (showLogo()) {
				<a class="flex shrink-0 items-center px-0.5" routerLink="/">
					<ui-icon width="22" height="22" iconName="easy-kala" />
				</a>
			}

			@for (item of headerRightSectionItems(); track item.eventId) {
				<ui-icon
					class="shrink-0 cursor-pointer px-1 {{ item.iconClass ?? '' }}"
					width="22"
					height="22"
					[attr.aria-label]="item.ariaLabel"
					[class.animate-spin]="spinningIds().has(item.eventId)"
					[iconName]="item.iconName"
					(animationiteration)="onSpinRoundComplete(item)"
					(click)="onItemClick(item)" />
			}

			@if (title()) {
				<span class="min-w-0 truncate text-3.75 font-bold" data-cy="kala-header-title">
					{{ title() }}
				</span>
			}
		</div>

		@if (showClock()) {
			<app-clock [symbol]="symbol()" />
		}

		<div class="flex min-w-0 flex-1 items-center justify-end gap-px">
			@for (item of headerLeftSectionItems(); track item.eventId) {
				<ui-icon
					class="shrink-0 cursor-pointer px-1 {{ item.iconClass ?? '' }}"
					width="22"
					height="22"
					[attr.aria-label]="item.ariaLabel"
					[class.animate-spin]="spinningIds().has(item.eventId)"
					[iconName]="item.iconName"
					(animationiteration)="onSpinRoundComplete(item)"
					(click)="onItemClick(item)" />
			}
		</div>
	</header>
}
